import React, { useState, useEffect } from 'react';

const AudioRecorder = () => {
  const [audioStream, setAudioStream] = useState(null);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [audioChunks, setAudioChunks] = useState([]);
  const [audioBuffer, setAudioBuffer] = useState(null);
  const [isRecording, setIsRecording] = useState(false);

  useEffect(() => {
    if (audioBuffer) {
      const audio = new Audio(audioBuffer);
      audio.play();
    }
  }, [audioBuffer]);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      setAudioStream(stream);

      const recorder = new MediaRecorder(stream);
      setMediaRecorder(recorder);

      recorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          setAudioChunks([...audioChunks, event.data]);
        }
      };

      recorder.onstop = () => {
        const blob = new Blob(audioChunks, { type: 'audio/wav' });
        const url = URL.createObjectURL(blob);
        setAudioBuffer(url);
        setAudioChunks([]);
      };

      recorder.start();
      setIsRecording(true);
    } catch (error) {
      console.error('Error accessing microphone:', error);
    }
  };

  const stopRecording = () => {
    if (mediaRecorder && audioStream) {
      mediaRecorder.stop();
      audioStream.getTracks().forEach((track) => track.stop());
      setIsRecording(false);
    }
  };

  return (
    <div>
      <button onClick={startRecording} disabled={isRecording}>
        Bắt đầu thu âm
      </button>
      <button onClick={stopRecording} disabled={!isRecording}>
        Ngừng thu âm
      </button>
      {audioBuffer && <audio controls src={audioBuffer} />}
    </div>
  );
};

export default AudioRecorder;
